import { useEffect } from "react";
import Card from "../components/Card";
import Loader from "../components/Loader";

export default function HomePage() {
    
    return (
        <>
            <div className="relative">

                <div className="mt-5">
                    <h1 className="text-center font-bold text-3xl text-white">Find Your Dream Job</h1>
                    <p className="text-center text-xl text-white mt-2">We guide you find exciting opportunities around the world.</p>
                    {/* <div className="h-72 w-full bg-white">

                </div> */}

                    <div className=" rounded-lg my-10">
                        <Card
                            poster={""}
                            title={"Android Development Training"}
                            description={"Master Android app development with our comprehensive training program. Learn from fundamentals to advanced topics, build projects, and gain practical experience. Enroll now to boost your career! Limited seats available."}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}